<div class="container">
  <div class="row justify-content-center">
    <div class="col-12">
      <nav class="navbar d-flex justify-content-between align-items-center py-3">
        <!-- ✅ الموبايل فقط -->
        <div
          class="navbar-mobile d-flex d-lg-none align-items-center justify-content-between w-100 position-relative"
        >
          <!-- burger icon -->
          <div class="hamburger ms-2 p-2" (click)="toggleMenu()">
            <img src="assets/images/icons/hamb_menu.svg" alt="menu icon" />
          </div>

          <!-- logo -->
          <div
            class="logo position-absolute top-50 start-50 translate-middle"
            (click)="refresHome()"
          >
            <img src="assets/images/logo.svg" height="45px" alt="logo" />
          </div>

          <!-- login button -->
          @if (!exist_user) {
            <div class="mobile-login-btn me-2">
              <a
                class="btn btn-outline-default text-default py-2 px-3"
                [routerLink]="['/auth/detect-type']"
                >Join</a
              >
            </div>
          }
        </div>
        <div
          class="navbar-desktop d-none d-lg-flex justify-content-between align-items-center w-100"
        >
          <div class="d-flex align-items-center">
            <div class="logo me-4" (click)="refresHome()">
              <img src="assets/images/logo.svg" height="50px" alt="logo" />
            </div>
            <div class="d-flex align-items-center gap-2 main_links">
              @if (type == 'client') {
                @for (item of clientNavItems; track item.path) {
                  <a [routerLink]="item.path" class="me-3">{{ item.label }}</a>
                }
              }

              @if (type == 'freelancer') {
                @for (item of freelancerNavItems; track item.path) {
                  <a [routerLink]="item.path" class="me-3">{{ item.label }}</a>
                }
              }

              <!-- <a [routerLink]="['/profile', user?.username]" class="me-3">Profile</a> -->
              <a [routerLink]="['/timeline']" class="me-3">Timeline</a>
            </div>
          </div>

          <div class="d-flex align-items-center flex-row gap-2">
            <app-search></app-search>

            <!-- <a class="d-flex">
              <span class="mx-2" style="vertical-align: bottom">English</span>
              <img
                src="assets/images/icons/language.svg"
                alt=""
                style="
                  width: 24px;
                  height: 24px;
                  filter: brightness(0) saturate(100%) invert(0%) sepia(100%) saturate(0%)
                    hue-rotate(188deg) brightness(95%) contrast(105%);
                "
              />
            </a> -->

            @if (exist_user) {
              <app-navbar-messages></app-navbar-messages>
            }
            @if (exist_user) {
              <app-navbar-notifications></app-navbar-notifications>
            }

            @if (exist_user) {
              <button mat-button [matMenuTriggerFor]="menu">
                <!-- <img
                  [src]="environment + user?.profile_picture"
                  alt="user profile"
                  width="35px"
                  height="35px"
                /> -->
                <app-user-profile-picture
                  [name]="user?.name || ''"
                  [imageUrl]="user?.profile_picture || ''"
                ></app-user-profile-picture>
              </button>
              <mat-menu #menu="matMenu">
                <ul mat-menu-item class="list-unstyled p-2 m-0">
                  @switch (user?.type) {
                    @case ('freelancer') {
                      <li class="d-flex gap-2 p-2 pt-1" (click)="goProfile(user?.username)">
                        <!-- [routerLink]="['/profile','freelancer',user?.username]"-->
                        <div class="align-self-center">
                          <!-- <img
                            [src]="environment + user?.profile_picture"
                            alt="freelancer profile"
                            width="45px"
                            height="45px"
                          /> -->
                          <app-user-profile-picture
                            [name]="user?.name || ''"
                            [imageUrl]="user?.profile_picture || ''"
                            [size]="45"
                          ></app-user-profile-picture>
                        </div>

                        <div class="align-self-center pb-2">
                          <p class="mb-0 fw-semibold">{{ user?.name }}</p>
                          <span class="email"> {{ user?.email }} </span>
                        </div>
                      </li>
                      @for (setting of freelancer_settings_menu; track setting) {
                        <li>
                          <a
                            class="dropdown-item mobile-close"
                            [routerLink]="setting.title === 'Profile' ? null : setting.path"
                            (click)="onSettingClick(setting)"
                          >
                            {{ setting.title }}
                          </a>
                        </li>
                        <!-- [routerLink]="setting.path"  -->
                      }
                    }
                    @case ('client') {
                      <li class="d-flex gap-2 p-2 pt-1" (click)="goProfile(user?.username)">
                        <!--[routerLink]="['/profile','client',user?.username]" -->
                        <div class="align-self-center">
                          <app-user-profile-picture
                            [name]="user?.name || ''"
                            [imageUrl]="user?.profile_picture || ''"
                            [size]="45"
                          ></app-user-profile-picture>
                        </div>

                        <div class="align-self-center pb-2">
                          <p class="mb-0 fw-semibold">{{ user?.name }}</p>
                          <span class="email"> {{ user?.email }} </span>
                        </div>
                      </li>
                      @for (setting of user_settings_menu; track setting) {
                        <li>
                          <a class="dropdown-item mobile-close" [routerLink]="[setting.path]">{{
                            setting.title
                          }}</a>
                        </li>
                      }
                    }
                  }
                  <li class="pt-1">
                    <a class="dropdown-item mobile-close text-black" (click)="logout()">Sign out</a>
                  </li>
                </ul>
              </mat-menu>
            }
            @if (!exist_user) {
              <a class="text-black me-2" [routerLink]="['/auth/login']">Log In</a>
              <a
                class="btn btn-outline-default text-default py-2 me-2"
                [routerLink]="['/auth/detect-type']"
                >Join</a
              >
            }
          </div>
        </div>
      </nav>
    </div>

    <div class="mobile-menu" [class.open]="isMenuOpen" [class.close]="!isMenuOpen">
      <!-- Header: close X on left, logo on right to match design -->
      <div class="mm-header">
        <button class="mm-close-btn" (click)="closeMenu()" aria-label="Close menu">
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1L17 17M17 1L1 17"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </button>
      </div>

      <div class="mm-body">
        @if (exist_user) {
          <!-- ===== User Profile Card ===== -->
          <div class="mm-user-card" (click)="toggleMobileUserDropdown()">
            <div class="mm-user-card__info">
              <app-user-profile-picture
                [name]="user?.name || ''"
                [imageUrl]="user?.profile_picture || ''"
                [size]="44"
              ></app-user-profile-picture>
              <div class="mm-user-card__text">
                <span class="mm-user-card__name">{{ user?.name }}</span>
                <span class="mm-user-card__email">{{ user?.email }}</span>
              </div>
            </div>
            <!-- Chevron toggles direction based on open state -->
            <svg
              class="mm-chevron"
              [class.mm-chevron--up]="isMobileUserDropdownOpen"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4 6L8 10L12 6"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>

          <!-- Profile sub-links (animated collapse) -->
          <div class="mm-submenu" [class.mm-submenu--open]="isMobileUserDropdownOpen">
            <a
              class="mm-submenu__item"
              [routerLink]="['/profile', user?.username]"
              (click)="closeMenu()"
            >
              Profile
            </a>
            <a
              class="mm-submenu__item"
              [routerLink]="['settings/personal-information']"
              (click)="closeMenu()"
            >
              Account settings
            </a>
            <a class="mm-submenu__item" [routerLink]="['/wallet']" (click)="closeMenu()">
              Wallet
            </a>
          </div>

          <div class="mm-divider"></div>

          <!-- ===== Type-specific nav items ===== -->
          @switch (type) {
            @case ('client') {
              @for (item of clientNavItems; track item.path) {
                <a class="mm-nav-item" [routerLink]="item.path" (click)="closeMenu()">
                  <span>{{ item.label }}</span>
                  <svg
                    class="mm-nav-arrow"
                    width="8"
                    height="14"
                    viewBox="0 0 8 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 1L7 7L1 13"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </a>
              }
            }
            @case ('freelancer') {
              @for (item of freelancerNavItems; track item.path) {
                <a class="mm-nav-item" [routerLink]="item.path" (click)="closeMenu()">
                  <span>{{ item.label }}</span>
                  <svg
                    class="mm-nav-arrow"
                    width="8"
                    height="14"
                    viewBox="0 0 8 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 1L7 7L1 13"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </a>
              }
            }
          }

          <!-- Timeline — shared for all logged-in users -->
          <a class="mm-nav-item" [routerLink]="['/timeline']" (click)="closeMenu()">
            <span>Timeline</span>
            <svg
              class="mm-nav-arrow"
              width="8"
              height="14"
              viewBox="0 0 8 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 1L7 7L1 13"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </a>

          <!-- Messages -->
          <a
            class="mm-nav-item mm-nav-item--with-icon mm-nav-item-no-border"
            [routerLink]="['/home']"
            (click)="closeMenu()"
          >
            <div class="mm-nav-item__left">
              <img
                src="assets/images/icons/message.svg"
                alt="messages icon"
                width="20"
                height="20"
                class="mm-icon"
              />
              <span>Messages</span>
            </div>
          </a>

          <!-- Notifications -->
          <a
            class="mm-nav-item mm-nav-item--with-icon mm-nav-item-no-border"
            [routerLink]="['/notifications']"
            (click)="closeMenu()"
          >
            <div class="mm-nav-item__left">
              <svg
                class="mm-icon"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M13.73 21C13.5542 21.3031 13.3019 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6982 21.5547 10.4458 21.3031 10.27 21"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span>Notifications</span>
            </div>
            <!-- Notification badge dot -->
            @if (hasUnviewed()) {
              <span class="mm-dot"></span>
            }
          </a>

          <!-- Language -->
          <!-- <a class="mm-nav-item mm-nav-item--with-icon mm-nav-item-no-border" (click)="closeMenu()">
            <div class="mm-nav-item__left">
              <img
                src="assets/images/icons/language.svg"
                alt="language icon"
                width="20"
                height="20"
                class="mm-lang-icon"
              />
              <span>العربية</span>
            </div>
          </a> -->

          <div class="mm-divider"></div>

          <!-- Sign out -->
          <button class="mm-signout-btn" (click)="closeMenu(); logout()">Sign out</button>
        } @else {
          <!-- ===== Guest view ===== -->
          <a class="mm-nav-item" [routerLink]="['/timeline']" (click)="closeMenu()">
            <span>Timeline</span>
            <svg
              class="mm-nav-arrow"
              width="8"
              height="14"
              viewBox="0 0 8 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 1L7 7L1 13"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </a>

          <!-- Language -->
          <!-- <a class="mm-nav-item mm-nav-item--with-icon mm-nav-item-no-border" (click)="closeMenu()">
            <div class="mm-nav-item__left">
              <img
                src="assets/images/icons/language.svg"
                alt="language icon"
                width="20"
                height="20"
                class="mm-lang-icon"
              />
              <span>العربية</span>
            </div>
          </a> -->

          <div class="mm-divider"></div>

          <!-- Join button -->
          <a class="mm-join-btn" [routerLink]="['/auth/detect-type']" (click)="closeMenu()">Join</a>

          <!-- Log In link -->
          <a class="mm-login-link" [routerLink]="['/auth/login']" (click)="closeMenu()">Log In</a>
        }
      </div>
    </div>
  </div>
</div>
